<template>
  <b-overlay :show="loading" variant="white" :opacity="0.9" rounded="false">
    <h4>{{ $t("Guests") }}</h4>

    <!-- CHANGE OF MESSAGE TEMPORARY TEST -->
    <!-- <b-alert variant="dark" :show="showAddClientAsGuestAlert" class="my-3">
      <div class="alert-body">
        <feather-icon
          icon="HelpCircleIcon"
          size="25"
          class="mr-1"
        ></feather-icon>
        {{ $t("pages.booking.addClientAsGuest") }}
        <b-button
          class="text-secondary ml-2 mr-3"
          size="sm"
          @click="onAddClientAsGuestButtonClicked"
        >
          {{ $t("Yes") }}
        </b-button>
        <b-button
          size="sm"
          class="text-secondary"
          @click="onDiscardAddClientAsGuestButtonClicked"
        >
          No
        </b-button>
      </div>
    </b-alert> -->

    <b-alert variant="dark" :show="showAddClientAsGuestAlert" class="my-3">
      <div class="alert-body">
        <feather-icon icon="AlertCircleIcon" size="25" class="mr-1"></feather-icon>
        {{ $t("pages.booking.suggestClientAsGuest") }}
      </div>
    </b-alert>

    <b-alert :show="capacityCompleted" class="my-3" variant="warning">
      <div class="alert-body">
        {{ $t("pages.booking.capacityCompleted") }}
      </div>
    </b-alert>

    <guests-list :guests="guests" :hide-button="capacityCompleted" class="mb-2" @add-guest="onAddGuest"
      @add-baby="onAddBaby" @edit-guest="onEditGuest" @delete-guest="onDeleteGuest" />

    <small v-if="invalidGuestsNumber" class="text-danger">
      {{ $t("pages.booking.checkin.atLeast1Guest") }}
    </small>

    <template v-if="showBabyRequestsAlert">
      <h4 class="mt-4">{{ $t("Special requests") }}</h4>
      <b-row>
        <b-col cols="12">
          <b-alert variant="secondary" :show="true" class="mb-0 mt-4">
            <div class="alert-body">
              <b-row class="mb-2">
                <b-col cols="12" sm="6" class="mb-3 mb-sm-0">
                  <label for="cots-spinbutton">
                    {{ $t("Baby chairs") }}
                  </label>
                  <b-form-spinbutton id="cots-spinbutton" v-model="babyCots" :min="0" :max="maxBabyItemsRequests" />
                </b-col>
                <b-col cols="12" sm="6">
                  <label for="highchairs-spinbutton">
                    {{ $t("Baby cots") }}
                  </label>
                  <b-form-spinbutton id="highchairs-spinbutton" v-model="babyChairs" :min="0"
                    :max="maxBabyItemsRequests" />
                </b-col>
              </b-row>
            </div>
          </b-alert>
        </b-col>
      </b-row>
    </template>

    <b-row class="mt-4 d-flex justify-content-between">
      <b-col cols="12" md="auto" class="mb-3 mb-md-0">
        <b-button variant="secondary" block @click="onShareButtonClicked">
          <feather-icon icon="ShareIcon" class="mr-2" />
          {{ $t("pages.booking.checkin.shareOnlineCheckinLinkButton") }}
        </b-button>
      </b-col>
      <b-col cols="12" md="auto">
        <b-button variant="primary" block @click="onSaveButtonClicked">
          {{ $t("pages.booking.checkin.confirmGuestsListButton") }}
        </b-button>
      </b-col>
    </b-row>

    <b-modal id="guest-modal" v-model="guestModalVisible" :title="guestModalTitle" hide-footer scrollable
      :no-close-on-esc="loadingGuest" :no-close-on-backdrop="loadingGuest" :hide-header-close="loadingGuest">
      <guest-form :guest="selectedGuest" :is-baby="isBaby" @guest-added="onGuestAdded"
        @add-guest-error="onAddGuestError" @guest-edited="onGuestEdited" @edit-guest-error="onEditGuestError"
        @loading="onGuestLoading" />
    </b-modal>

    <b-modal id="share-online-checkin-modal" :title="$t('pages.booking.checkin.shareOnlineCheckinModalTitle')"
      hide-footer centered size="md">
      <div class="share-checkin-container text-center">
        <feather-icon icon="UsersIcon" size="48" class="text-primary mb-4" />
        <h5 class="font-weight-bold mb-3">{{ $t('pages.booking.checkin.shareOnlineCheckinModalHeadline') }}</h5>
        <p class="mb-3">{{ $t('pages.booking.checkin.shareOnlineCheckinModalDescription') }}</p>

        <div class="share-link-container d-flex align-items-center mb-4">
          <b-form-input readonly :value="shareOnlineCheckinLink" class="mr-2" />
          <b-button v-b-tooltip.hover variant="outline-primary" :title="linkCopied ? $t('Copied!') : $t('Copy')"
            @click="copyLinkToClipboard">
            <feather-icon :icon="linkCopied ? 'CheckIcon' : 'CopyIcon'" size="16" />
          </b-button>
        </div>

        <div class="share-options">
          <h6 class="mb-3">{{ $t('pages.booking.checkin.shareOnlineCheckinModalShareVia') }}:</h6>
          <div class="d-flex justify-content-center">
            <b-button v-b-tooltip.hover variant="outline-primary" class="mx-2 sharing-button" title="WhatsApp"
              @click="shareViaWhatsApp">
              <feather-icon icon="MessageSquareIcon" size="18" />
            </b-button>
            <b-button v-b-tooltip.hover variant="outline-primary" class="mx-2 sharing-button" title="Email"
              @click="shareViaEmail">
              <feather-icon icon="MailIcon" size="18" />
            </b-button>
            <b-button v-b-tooltip.hover variant="outline-primary" class="mx-2 sharing-button" title="SMS"
              @click="shareViaSMS">
              <feather-icon icon="SmartphoneIcon" size="18" />
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BOverlay,
  BRow,
  BCol,
  BButton,
  BFormSpinbutton,
  BAlert,
  BModal,
  BFormInput
} from "bootstrap-vue";
import { VBTooltip } from "bootstrap-vue";
import { formatDateObjectToDatabaseDateTime } from "@/utils/formatters";
import GuestsList from "@/views/foravila/bookings/booking/components/checkin/GuestsList.vue";
import GuestForm from "@/views/foravila/bookings/booking/components/checkin/GuestForm.vue";
import { copyToClipboard, getGuestsExpandedText, notifyError, scrollToId } from "@/utils/methods";

export default {
  components: {
    BOverlay,
    BRow,
    BCol,
    BButton,
    BFormSpinbutton,
    BAlert,
    GuestsList,
    BModal,
    GuestForm,
    BFormInput
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      loading: false,
      loadingGuest: false,
      discartedAlert: false,
      guestModalTitle: null,
      guestModalVisible: false,
      selectedGuest: null,
      babies: 0,
      babyCots: 0,
      babyChairs: 0,
      invalidGuestsNumber: false,
      isBaby: false,
      linkCopied: false
    };
  },
  computed: {
    accommodation() {
      return this.$store.getters["booking/accommodation"];
    },
    booking() {
      return this.$store.getters["booking/booking"];
    },
    details() {
      return this.$store.getters["booking/details"];
    },
    stats() {
      return this.$store.getters["booking/stats"];
    },
    guests() {
      return this.$store.getters["booking/guests"];
    },
    adultsCount() {
      return this.$store.getters["booking/guestsAdultsCount"];
    },
    childrenCount() {
      return this.$store.getters["booking/guestsChildrenCount"];
    },
    babiesCount() {
      return this.$store.getters["booking/guestsBabiesCount"];
    },
    client() {
      return this.$store.getters["client/client"];
    },
    clientOnlineCheckinCompleted() {
      return this.$store.getters["booking/clientOnlineCheckinCompleted"];
    },
    guestsOnlineCheckinCompleted() {
      return this.$store.getters["booking/guestsOnlineCheckinCompleted"];
    },
    onlineCheckinCompleted() {
      return this.$store.getters["booking/onlineCheckinCompleted"];
    },
    showAddClientAsGuestAlert() {
      if (
        !this.client ||
        this.discartedAlert ||
        !this.clientOnlineCheckinCompleted ||
        this.guestsOnlineCheckinCompleted ||
        this.capacityCompleted
      )
        return false;

      // Check if the client can be already found in the guests list
      const clientGuest = this.guests.find(
        guest => guest.idNumber === this.client.idNumber
      );
      return !clientGuest;
    },
    showBabyRequestsAlert() {
      return (this.babiesCount + this.childrenCount) > 0;
    },
    capacityCompleted() {
      if (!this.accommodation?.capacity) return null;
      const guestsCount = (this.adultsCount || 0) + (this.childrenCount || 0);
      const capacity = this.accommodation?.capacity || 0;
      return guestsCount >= capacity;
    },
    maxBabyItemsRequests() {
      return Math.min(this.babiesCount, 2);
    },
    shareOnlineCheckinLink() {
      return `${window.location.origin}/online-checkin-share/${this.booking.localizator}?key=${this.booking.uuid}&l=${this.$i18n?.locale}`;
    },
    guestsListHtml() {
      const lis = this.guests.map(guest => {
        return `<li>${guest.firstName} ${guest.lastName}</li>`;
      }).join("");
      return `<ul style="list-style: square;text-align: left;">${lis}</ul>`;
    },
    confirmGuestsListContent() {
      return `<p style="text-align: left;">${this.$t("pages.booking.checkin.allGuestsRegisteredPopup", {
        guests: getGuestsExpandedText(
          {
            adults: this.adultsCount,
            children: this.childrenCount,
            babies: this.babiesCount
          },
          this.$i18n.locale
        )
      })}</p><p>${this.guestsListHtml}</p><p style="text-align: left;"><small>${this.$t("pages.booking.checkin.allGuestsRegisteredPopupWarning")}</small></p>`;
    }
  },
  watch: {
    babies(babies) {
      if (!babies) {
        this.babyCots = 0;
        this.babyChairs = 0;
      } else {
        // If the number of selected cots/chairs is higher than the number of selected babies,
        // set the new number of selected cots/chairs equal to the number of babies.
        this.babyCots = this.babyCots > babies ? babies : this.babyCots;
        this.babyChairs = this.babyChairs > babies ? babies : this.babyChairs;
      }
    },
    guestModalVisible(visible) {
      if (!visible) this.selectedGuest = null;
    }
  },
  methods: {
    onAddClientAsGuestButtonClicked() {
      this.guestModalTitle = this.$t("pages.booking.addNewGuest");
      this.selectedGuest = {
        gender: this.client.gender,
        firstName: this.client.firstName,
        lastName: this.client.lastName,
        birthDate: this.client.birthDate,
        nationality: this.client.nationality,
        idType: this.client.idType,
        idNumber: this.client.idNumber
      };
      this.$bvModal.show("guest-modal");
    },
    onGuestLoading(loading) {
      this.loadingGuest = loading;
    },
    onEditGuest(guest) {
      this.selectedGuest = guest;
      this.isBaby = guest.age <= 1;
      this.guestModalTitle = this.$t("pages.booking.editGuest");
      this.$bvModal.show("guest-modal");
    },
    onDeleteGuest(guest) {
      this.selectedGuest = guest;
      this.$swal({
        text: this.$t("pages.booking.deleteGuestPrompt", {
          name: guest.firstName
        }),
        icon: "error",
        showCancelButton: true,
        confirmButtonText: this.$t("Delete"),
        cancelButtonText: this.$t("Cancel"),
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-outline-danger ml-4"
        },
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteSelectedGuest();
        }
      });
    },
    deleteSelectedGuest() {
      this.loading = true;
      this.$store
        .dispatch("booking/deleteGuest", this.selectedGuest.uuid)
        .catch(() =>
          notifyError(
            this.$t("errors.deleteGuest.title"),
            this.$t("errors.deleteGuest.text")
          )
        )
        .finally(() => {
          this.loading = false;
        });
    },
    onAddGuest() {
      this.guestModalTitle = this.$t("pages.booking.addNewGuest");
      this.selectedGuest = null;
      this.isBaby = false;
      this.$bvModal.show("guest-modal");
    },
    onGuestAdded() {
      this.$bvModal.hide("guest-modal");
      this.invalidGuestsNumber = false;
    },
    onAddGuestError() {
      this.$bvModal.hide("guest-modal");
    },
    onGuestEdited() {
      this.$bvModal.hide("guest-modal");
    },
    onEditGuestError() {
      this.$bvModal.hide("guest-modal");
    },
    onAddBaby() {
      this.guestModalTitle = this.$t("pages.booking.addNewBaby");
      this.selectedGuest = null;
      this.isBaby = true;
      this.$bvModal.show("guest-modal");
    },
    onDiscardAddClientAsGuestButtonClicked() {
      this.discartedAlert = true;
      // TODO: store and collect this value from a cookie
    },
    onSaveButtonClicked() {
      if (this.adultsCount > 0) {
        this.$swal({
          html: this.confirmGuestsListContent,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: this.$t("Confirm"),
          cancelButtonText: this.$t("Cancel"),
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-4"
          },
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.save();
          }
        });
      } else {
        this.invalidGuestsNumber = true;
      }
    },
    save() {
      this.loading = true;

      const promises = [];

      // Update Booking
      // promises.push(
      //   this.$store.dispatch("booking/updateBooking", {
      //     uuid: this.booking.uuid,
      //     children: this.childrenCount,
      //     babies: this.babiesCount,
      //     adults: this.adultsCount
      //   })
      // );

      // Update BookingDetails
      promises.push(
        this.$store.dispatch("booking/updateDetails", {
          uuid: this.details.uuid,
          babyChairs: this.babyChairs,
          babyCots: this.babyCots
        })
      );

      // If all promises are OK, update the BookingStats
      Promise.all(promises)
        .then(() => {
          this.$store
            .dispatch("booking/updateStats", {
              uuid: this.stats.uuid,
              guestsOnlineCheckinCompleted: true,
              guestsOnlineCheckinCompletedAt: formatDateObjectToDatabaseDateTime(
                new Date()
              )
            })
            .finally(() => {
              this.loading = false;
              if (this.onlineCheckinCompleted)
                scrollToId("checkin-status-card", 100);
              else scrollToId("guests-card", 100);
            });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onShareButtonClicked() {
      this.$bvModal.show("share-online-checkin-modal");
    },
    copyLinkToClipboard() {
      copyToClipboard(this.shareOnlineCheckinLink)
      this.linkCopied = true;
      setTimeout(() => {
        this.linkCopied = false;
      }, 2000);
    },
    onShareLinkCoppied() {
      this.linkCopied = true;
      setTimeout(() => {
        this.linkCopied = false;
      }, 2000);
    },
    shareViaWhatsApp() {
      const url = `https://wa.me/?text=${encodeURIComponent(this.shareOnlineCheckinLink)}`;
      window.open(url, '_blank');
    },
    shareViaEmail() {
      const subject = this.$t('Share with your travelmates');
      const body = this.$t('Invite your travel companions to complete their details') + '\n\n' + this.shareOnlineCheckinLink;
      const url = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      window.open(url, '_blank');
    },
    shareViaSMS() {
      const url = `sms:?body=${encodeURIComponent(this.shareOnlineCheckinLink)}`;
      window.open(url, '_blank');
    }
  }
};
</script>

<style lang="scss">
#share-online-checkin-modal {
  .share-checkin-container {
    padding: 1rem;

    .share-link-container {
      background-color: rgba(115, 103, 240, 0.05);
      border-radius: 0.5rem;
      padding: 0.75rem;
      margin: 1.5rem 0;

      .b-form-input {
        background-color: white;
        border-color: #ebe9f1;
      }
    }

    .sharing-button {
      height: 45px;
      width: 45px;
      border-radius: 50%;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.25s ease;

      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 4px 8px rgba(115, 103, 240, 0.3);
      }
    }

    .share-options {
      border-top: 1px solid #ebe9f1;
      padding-top: 1.5rem;
      margin-top: 1rem;
    }
  }
}
</style>
